import React from "react";

export default props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : "24"}
    height={props.height ? props.height : "24"}
    viewBox="0 0 24 24"
  >
    <title>Επιστροφή</title>
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      className="arrow-actual"
      strokeDasharray="70"
      strokeDashoffset="70"
      stroke="black"
      strokeWidth="0.2"
      fill={props.color ? props.color : null}
      d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/IconArrow.js